import { render, staticRenderFns } from "./reservation-main.vue?vue&type=template&id=065be50c&"
import script from "./reservation-main.vue?vue&type=script&lang=js&"
export * from "./reservation-main.vue?vue&type=script&lang=js&"
import style0 from "./reservation-main.vue?vue&type=style&index=0&id=065be50c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports